import {
  NOTIFICATION_SAVED,
  NOTIFICATION_ERROR,
  NOTIFICATION_RESET,
  UPDATE_ACTION_ID,
  UPDATE_DIALOG_TEXT,
  NOTIFICATION_REMOVED,
  DEFERRED_STATUS_TEXT,
} from '@web-platform/shared-universal-types/src/saveToList';

import type {
  TogglePriceAlertInfo,
  SaveItineraryWhileLoggedOutAction,
  LoginFlowCompletedAction,
  SaveLimitErrorDialogDismissedAction,
} from '@web-platform/shared-universal-types/src/redux/acorn/actions/actions-acorn-types';
import type {
  SaveToListNotificationSavedAction,
  SaveToListNotificationResetAction,
  SaveToListNotificationErrorAction,
  SaveToListUpdateActionIdAction,
  SaveToListUpdateDialogTextAction,
  SaveToListNotificationRemovedAction,
  SaveToListDeferredStatusTextAction,
} from '@web-platform/shared-universal-types/src/redux/actions/actions-shared-types';
import type {
  SaveToListNotificationSavedWithStatusTextAction,
  SaveToListResetDialogTextAction,
} from '@web-platform/shared-universal-types/src/redux/banana/actions/actions-banana-types';
import type { S2LNotificationSource } from '@web-platform/shared-universal-types/src/saveToList';

export const NOTIFICATION_SAVED_WITH_STATUS_TEXT = 'NOTIFICATION_SAVED_WITH_STATUS_TEXT';
export const RESET_DIALOG_TEXT = 'RESET_DIALOG_TEXT';
export const SAVE_ITINERARY_WHILE_LOGGED_OUT = 'SAVE_ITINERARY_WHILE_LOGGED_OUT';
export const LOGIN_FLOW_COMPLETED = 'LOGIN_FLOW_COMPLETED';
export const SAVE_LIMIT_ERROR_DIALOG_DISMISSED = 'SAVE_LIMIT_ERROR_DIALOG_DISMISSED';
export const TOGGLE_PRICE_ALERT_INFO = 'TOGGLE_PRICE_ALERT_INFO';
export const TRACK_HEART_ICON_CLICKED = 'TRACK_HEART_ICON_CLICKED';

type StatusText = { statusText: string };

type Source = {
  source: S2LNotificationSource;
};

type SourceAndStatusText = Source & StatusText;

export function notificationSavedWithStatusText({
  source,
  statusText,
}: SourceAndStatusText): SaveToListNotificationSavedWithStatusTextAction {
  return {
    type: NOTIFICATION_SAVED_WITH_STATUS_TEXT,
    payload: {
      statusText,
      source,
    },
  };
}

export function notificationRemovedWithStatusText({
  source,
  statusText,
}: SourceAndStatusText): SaveToListNotificationRemovedAction {
  return {
    type: NOTIFICATION_REMOVED,
    payload: {
      statusText,
      source,
    },
  };
}

export function notificationSaved(
  sourceOrObject: S2LNotificationSource | Source,
  statusText?: string,
  tripId?: string,
): SaveToListNotificationSavedAction {
  const source = typeof sourceOrObject === 'object' ? sourceOrObject.source : sourceOrObject;

  if (statusText) {
    return {
      type: NOTIFICATION_SAVED,
      payload: { statusText, tripId, source },
    };
  }
  return {
    type: NOTIFICATION_SAVED,
    payload: { source },
  };
}

export function notificationRemoved(
  statusText: string,
  source: S2LNotificationSource,
): SaveToListNotificationRemovedAction {
  return notificationRemovedWithStatusText({ source, statusText });
}

export function notificationReset(): SaveToListNotificationResetAction {
  return {
    type: NOTIFICATION_RESET,
  };
}

export function notificationError(
  sourceOrObject: S2LNotificationSource | Source,
): SaveToListNotificationErrorAction {
  const source = typeof sourceOrObject === 'object' ? sourceOrObject.source : sourceOrObject;

  return {
    type: NOTIFICATION_ERROR,
    payload: {
      source,
    },
  };
}

export function updateActionId(actionId: string): SaveToListUpdateActionIdAction {
  return {
    type: UPDATE_ACTION_ID,
    payload: {
      actionId,
    },
  };
}

export function updateDialogText(
  headingText: string,
  subHeadingText: string,
): SaveToListUpdateDialogTextAction {
  return {
    type: UPDATE_DIALOG_TEXT,
    payload: {
      headingText,
      subHeadingText,
    },
  };
}

export function resetDialogText(): SaveToListResetDialogTextAction {
  return {
    type: RESET_DIALOG_TEXT,
  };
}

export function saveItineraryWhileLoggedOut(
  itineraryId: string,
): SaveItineraryWhileLoggedOutAction {
  return {
    type: SAVE_ITINERARY_WHILE_LOGGED_OUT,
    payload: { itineraryId },
  };
}

export function loginFlowCompleted(): LoginFlowCompletedAction {
  return {
    type: LOGIN_FLOW_COMPLETED,
  };
}

export function saveLimitErrorDialogDismissed(): SaveLimitErrorDialogDismissedAction {
  return {
    type: SAVE_LIMIT_ERROR_DIALOG_DISMISSED,
  };
}

export function togglePriceAlertInfo(): TogglePriceAlertInfo {
  return {
    type: TOGGLE_PRICE_ALERT_INFO,
  };
}

export function deferredStatusText(statusText: string): SaveToListDeferredStatusTextAction {
  return {
    type: DEFERRED_STATUS_TEXT,
    payload: {
      statusText,
    },
  };
}
